export function JournalIcon({ className }: { className?: string }) {
  return <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M6 4h14v16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 0v16M9 8h7m-7 4h7m-7 4h4" />
  </svg>;
}
